import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {devConfig, profile} from "config/config"; // Importing configuration settings
import "webix/photo"; // Importing photo module from webix
import "webix/tinymce/tinymce"; // Importing TinyMCE editor from webix

/**
 * Class representing the FilterReportsView.
 * @extends JetView
 */
export default class FilterReportsView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config(){
        const _ = this.app.getService("locale")._; // Localization service
        const fecha = {
            margin: 5,
            id:"a1",
            rows: [{
                margin: 15,
                css: "on-row",
                responsive:"a1",
                cols: [
                    {
                        view: "text", name: "Datepicker", id:'Datepicker', css:"reportrange", readonly:true,
                        label: "<span class='webix_icon icon-calendar'></span>" +  _("Fecha"), labelPosition: "top",
                        placeholder: _("Click para seleccionar ") // Placeholder for datepicker
                    },
                    {
                        view:"datepicker", name:"Date", id:"Date", stringResult:true, minWidth:200,
                        label:  "<span class='webix_icon icon-calendar'></span>" + _("Fecha"), labelPosition:"top",
                        placeholder:_("Click para seleccionar "), value: moment().format('YYYY-MM-DD'), // Default date value
                        format:"%d %M %Y", // Date format
                        suggest:{
                            type:"calendar",
                            body:{
                                maxDate:new Date() // Maximum date selectable
                            }
                        }
                    }
                ] }]
        };
        const transactionId = {
            margin:5, minWidth: 200,
            rows:[
            ]
        };
        const upper_section = {
            css: "father-container",
            rows:[{
                margin: 10,
                cols:[
                    fecha, // Date selection section
                    transactionId // Transaction ID section
                ]
            }]
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view:"button", value:_("Limpiar"), width: 100,
                    click:() => {
                        this.getRoot().clear(); // Clear the form
                    }
                },
                {
                    view:"button", value:_("Consultar"), type:"form", width: 110, id: "consultDesk",
                    click:() => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Add country to filter data
                        }
                        if (devConfig.getPartnerSelected()) {
                            filterdata.Partner = profile.PartnerSelected; // Add partner to filter data
                        }
                        if(profile.typeDate !== 2){
                            delete filterdata['Date']; // Remove date if typeDate is not 2
                        }else{
                            if(true){
                                delete filterdata['Datepicker']; // Remove datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent("taxPaymentsReport:filter",[filterdata]) // Trigger filter event
                        $$("b5").collapse(); // Collapse the accordion
                    }
                }
            ]
        };
        const buttons2 = {
            margin: 10,
            cols: [
                {},
                {
                    view:"button", value:_("Limpiar"), width: 100,
                    click:() => {
                        $$('myForm2').clear(); // Clear the second form
                    }
                },
                {
                    view:"button", value:_("Consultar"), type:"form", width: 110, id: "consultDesk",
                    click:() => {
                        const filterdata =$$('myForm2').getValues(); // Get values from second form
                        if(profile.typeDate !== 2){
                            delete filterdata['Date']; // Remove date if typeDate is not 2
                        }else{
                            if(true){
                                delete filterdata['Datepicker']; // Remove datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent("taxPaymentsReport:filter",[filterdata]) // Trigger filter event
                    }
                }
            ]
        };
        const accordion_section2 = {
            type:"wide",
            rows: [
                {
                    multi: true,
                    view: "accordion",
                    css: "betShop",
                    collapsed: true,
                    type: "clean",
                    rows: [
                        {
                            header: _("Filtros"), id: "b5", body: {
                                padding:10,
                                rows: [upper_section, buttons] // Upper section with buttons
                            }
                        }
                    ]
                }
            ]
        };
        const accordion_section3 = {
            padding: 10,
            rows: [upper_section, buttons2] // Upper section with second set of buttons
        };
        const filterPopup = webix.ui({
            view:"window",
            move:true,
            id:"filterPopup",
            fullscreen: true,
            head: {
                view: "toolbar",
                cols: [
                    {view: "label", label: _("Filtros"), align: "center"}, // Label for the popup
                    {
                        view: "icon", icon: "wxi-close", click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        }
                    }
                ]
            },
            modal:true,
            position:"center",
            body: {
                view: "form", id: 'myForm2',
                type: "clean",
                rows: [
                    accordion_section3 // Accordion section in the popup
                ],
                rules: {
                    "fname": webix.rules.isNotEmpty // Validation rule for form
                }
            }
        });
        return {
            view: "form",
            type: "clean",
            rows: [
                (screen.width > 500 && screen.height > 500) ? accordion_section2 : {id:"right2",height:1,width:screen.width-54} // Responsive design
            ],
            rules: {
                "fname": webix.rules.isNotEmpty // Validation rule for main form
            }
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const lang = this.app.getService("locale").getLang(); // Get current language
        $$('Datepicker').attachEvent("onAfterRender", function(){
            devConfig.setDateModal(lang); // Set date modal based on language
        });
        webix.ready(function(){
            if(profile.typeDate !== 2){
                $$("Date").hide(); // Hide date if typeDate is not 2
                $$("Datepicker").show(); // Show datepicker
            }else{
                if(true){
                    $$("Date").show(); // Show date if typeDate is 2
                    $$("Datepicker").hide(); // Hide datepicker
                }
            }
        });
    }
}

// FILE DOCUMENTED
